export default {
  chatTicketCosts: state => state.chatTicketCosts,
  chatTicketsOpen: state => state.chatTicketsOpen,
  chatTicketsClose: state => state.chatTicketsClose,
  sumTypeCosts: state => state.sumTypeCosts,
  chatTicketTypes: state => state.chatTicketTypes,
}
